var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Component, Prop } from "vue-facing-decorator";
import { AlarmDefinitionsClient, LookupsClient, AlarmDefinitionModel, CreateAlarmDefinitionCommand, UpdateAlarmDefinitionCommand, AlarmSeverityEnum } from "@/app/api/battery-portal-api";
import { Notifier } from "@/common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
import { TextHelper } from "@/app/utils/text-helper";
import { useForm } from 'vee-validate';
import * as yup from 'yup';
const alarmDefinitionClient = new AlarmDefinitionsClient(window.apiUrl);
const lookupClient = new LookupsClient(window.apiUrl);
let AlarmDefinitionsVue = class AlarmDefinitionsVue extends Vue {
    constructor() {
        super(...arguments);
        this.working = false;
        this.searchAttempted = false;
        this.editingAlarmDefinition = false;
        // models
        this.data = [];
        this.alarmDefinition = new AlarmDefinitionModel();
        // arrays
        this.alarmSeverities = [];
    }
    created() {
    }
    ;
    mounted() {
        this.search();
        this.getLookups();
    }
    ;
    // get
    search() {
        if (!this.alarmTypeId)
            return;
        this.working = true;
        this.searchAttempted = true;
        alarmDefinitionClient
            .getAlarmTypeDefinitions(this.alarmTypeId)
            .then(response => {
            this.data = response;
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    get() {
    }
    ;
    getLookups() {
        lookupClient
            .getAlarmSeverities()
            .then(respone => {
            this.alarmSeverities = respone.map(alarmSeverity => {
                return {
                    value: alarmSeverity.alarmSeverityId,
                    text: alarmSeverity.alarmSeverityName
                };
            });
        });
    }
    ;
    // set
    initAlarmDefinition() {
        let alarmDefinition = new AlarmDefinitionModel();
        alarmDefinition.init({
            alarmTypeId: this.alarmTypeId,
            alarmSeverityId: AlarmSeverityEnum.Info
        });
        this.alarmDefinition = alarmDefinition;
    }
    ;
    save() {
        if (this.working)
            return;
        // validate
        const handleSubmitAction = this.handleSubmit(() => {
            let alarmDefinition = this.alarmDefinition;
            let promise = () => {
                return !this.alarmDefinition.alarmDefinitionId
                    ? alarmDefinitionClient.add(new CreateAlarmDefinitionCommand({ requestModel: alarmDefinition }))
                    : alarmDefinitionClient.update(alarmDefinition.alarmDefinitionId, new UpdateAlarmDefinitionCommand({ requestModel: alarmDefinition }));
            };
            this.working = true;
            promise()
                .then(() => {
                Notifier.onOk();
                this.editingAlarmDefinition = false;
                this.working = false;
                this.search();
            })
                .catch((ex) => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            }).finally(() => {
                this.working = false;
            });
        }, () => {
            Notifier.onError("Please check that you have entered all details correctly.");
        });
        handleSubmitAction();
    }
    ;
    add() {
        this.initAlarmDefinition();
        this.editingAlarmDefinition = true;
    }
    ;
    edit(alarm) {
        this.editingAlarmDefinition = true;
        let alarmDefinition = new AlarmDefinitionModel();
        alarmDefinition.init({});
        alarmDefinition.alarmDefinitionId = alarm.alarmDefinitionId;
        alarmDefinition.alarmSeverityId = alarm.alarmSeverityId;
        alarmDefinition.alarmTypeId = this.alarmTypeId;
        alarmDefinition.alarmDefinitionName = alarm.alarmDefinitionName;
        alarmDefinition.showValue = alarm.showValue;
        alarmDefinition.showHighValue = alarm.showHighValue;
        alarmDefinition.whenCreated = alarm.whenCreated;
        alarmDefinition.whenDeleted = alarm.whenDeleted;
        this.alarmDefinition = alarmDefinition;
        this.setValues({
            name: this.alarmDefinition.alarmDefinitionName,
        });
    }
    ;
    archive(alarm) {
        if (this.working)
            return;
        this.$confirmModal.show("Are you sure you want to archive this component", { title: "Please Confirm" })
            .then((value) => {
            if (!value)
                return;
            this.working = true;
            alarmDefinitionClient
                .delete(alarm.alarmDefinitionId)
                .then(() => {
                Notifier.onOk();
                this.working = false;
                this.search();
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
                this.editingAlarmDefinition = false;
            });
        });
    }
    ;
    restore(alarm) {
        if (this.working)
            return;
        this.working = true;
        alarmDefinitionClient
            .restore(alarm.alarmDefinitionId)
            .then(() => {
            Notifier.onOk();
            this.working = false;
            this.search();
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.editingAlarmDefinition = false;
        });
    }
    ;
    cancel() {
        this.editingAlarmDefinition = false;
        this.initAlarmDefinition();
    }
    ;
    get isNewAlarmDefinition() {
        return !this.alarmDefinition.alarmDefinitionId;
    }
    ;
    get isArchivedAlarmDefinition() {
        return this.alarmDefinition.whenDeleted ? true : false;
    }
    ;
    get selectPlaceholder() {
        return TextHelper.emptyListItemName;
    }
    ;
    get alarmSeverityId() {
        return this.alarmDefinition.alarmSeverityId;
    }
    ;
    get alarmSeverity() {
        return this.alarmSeverities.filter(item => {
            return item.value == this.alarmDefinition.alarmSeverityId;
        })[0] || null;
    }
    ;
    set alarmSeverity(item) {
        if (!this.alarmDefinition)
            return;
        this.alarmDefinition.alarmSeverityId = item.value;
    }
    ;
    get noData() {
        return this.searchAttempted && (!this.data || !this.data.length);
    }
    ;
};
__decorate([
    Prop(),
    __metadata("design:type", Number)
], AlarmDefinitionsVue.prototype, "alarmTypeId", void 0);
AlarmDefinitionsVue = __decorate([
    Component({
        name: "AlarmDefinitionsVue",
        setup() {
            const { errors, handleSubmit, defineInputBinds, setValues } = useForm({
                validationSchema: yup.object({
                    name: yup.string().trim().required(),
                }),
            });
            const nameVal = defineInputBinds('name');
            return {
                errors,
                handleSubmit,
                setValues,
                nameVal,
            };
        }
    })
], AlarmDefinitionsVue);
export default AlarmDefinitionsVue;
